var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortlarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14152.532 6310)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sort-a",
    width: 13.334,
    height: 1.6,
    transform: "translate(14163.198 -6310)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "sort-a",
    width: 9.334,
    height: 1.6,
    transform: "translate(14163.198 -6304.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "sort-a",
    width: 5.334,
    height: 1.6,
    transform: "translate(14163.198 -6299.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sort-a",
    d: "M16.834,15.268l-1.3-1.314-3.4,3.614V-2.983H10.2V17.568L6.8,13.953,5.5,15.268l5.667,5.75Z",
    transform: "translate(14147.032 -6307.017)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortlarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sortlarge.012f49fdd0a3e933f86f51227a152c22.svg";